exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.blinking{\n    animation:blinkingText 1.5s infinite;\n}\n@keyframes blinkingText{\n0%{     opacity: 1;\n}\n10%{    opacity: 0.8;\n}\n20%{    opacity: 0.6;\n}\n30%{    opacity: 0.4;\n}\n40%{    opacity: 0.2;\n}\n50%{    opacity: 0;\n}\n60%{    opacity: 0.2;\n}\n70%{    opacity: 0.4;\n}\n80%{    opacity: 0.6;\n}\n90%{    opacity: 0.8;\n}\n100%{   opacity: 1;\n}\n}\n", ""]);

// exports
